/**
 * Submission modal: opens form submission detail in a Bootstrap modal
 * via AJAX instead of navigating to a new page.
 *
 * Usage: <div data-init="initSubmissionTable"> wrapping the table.
 * Expects a #submissionModal with a #submissionModalBody in the page.
 */
(function () {
  var spinner = '<div class="text-center py-4">' +
    '<div class="spinner-border text-secondary" role="status">' +
    '<span class="visually-hidden">Loading...</span>' +
    '</div></div>';

  main.initSubmissionTable = function (el) {
    var modalEl = document.getElementById('submissionModal');
    var modalBody = document.getElementById('submissionModalBody');
    if (!modalEl || !modalBody) return;
    var modal = new bootstrap.Modal(modalEl);

    el.querySelectorAll('table tbody tr').forEach(function (row) {
      var span = row.querySelector('[data-href]');
      if (!span) return;
      row.setAttribute('data-href', span.dataset.href);
      row.style.cursor = 'pointer';
      row.addEventListener('click', function () {
        modalBody.innerHTML = spinner;
        modal.show();
        fetch(span.dataset.href, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
        .then(function (resp) { return resp.text(); })
        .then(function (html) { modalBody.innerHTML = html; })
        .catch(function () {
          modalBody.innerHTML = '<div class="text-danger">Failed to load submission.</div>';
        });
      });
    });
  };
})();
